module.exports = __webpack_public_path__ + "img/img7.318fe43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/03/img7.png
// module id = 52
// module chunks = 0